import { useAppDispatch } from '@/app/hooks'
import { FixedNavBar } from '@/components/atoms/FixedNavBar'
import {
  getTrackBeezerBySearch,
  getTrackBySearch,
  setIsWriting
} from '@/features/search/searchSlice'
import { useDebounce } from '@/hooks/useDebounce'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import closeIcon from '@/assets/icons/close.svg'
import './searchInput.scss'

const SearchInputForm = ({ isGuest }: { isGuest: boolean }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const debouncedValue = useDebounce({
    value,
    delay: 600
  })

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setValue(value)
  }

  const onClickInput = () => {
    dispatch(setIsWriting(true))
  }

  const onClearInput = () => {
    setValue('')
    dispatch(setIsWriting(false))
  }

  useEffect(() => {
    const onSearch = (current: string) => {
      if (!current) return
      if (current.length > 0) {
        dispatch(setIsWriting(true))
      }
      if (isGuest) {
        dispatch(getTrackBeezerBySearch(current))
        return
      }
      dispatch(getTrackBySearch(current))
    }

    onSearch(debouncedValue)
  }, [debouncedValue, dispatch, isGuest])

  return (
    <>
      <FixedNavBar>
        <input
          onClick={() => onClickInput()}
          className='m-search__input'
          type='text'
          placeholder={t('search.placeholder') || 'Search'}
          ref={inputRef}
          value={value}
          onChange={handleSearchInputChange}
        />
        {value && (
          <img
            src={closeIcon}
            alt='close'
            className='m-search__close'
            onClick={onClearInput}
          />
        )}
      </FixedNavBar>
    </>
  )
}

const SearchInput = React.memo(SearchInputForm)

export { SearchInput }
